// websoket 地址
// let webSoketUrl = 'wss://socket.zhizhumaimai.com/ws'
let webSoketUrl = 'wss://socket.zzxxweb.com/ws'
export default webSoketUrl